import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Search, Filter, Upload, FolderOpen, FileText, File } from 'lucide-react';
import BackButton from '../../components/BackButton';

const ArchiveDashboard = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [categoryFilter, setCategoryFilter] = useState('All');
  const [dateFilter, setDateFilter] = useState('all');
  const [documents, setDocuments] = useState([]);

  useEffect(() => {
    // Mock data - replace with actual API call
    const mockDocuments = [
      {
        id: 1,
        name: 'Supplier Agreement 2024',
        category: 'Contracts',
        date: '2024-01-15',
        type: 'pdf',
        size: '2.5 MB',
        tags: ['supplier', 'agreement'],
        physicalLocation: 'Cabinet A-1',
        status: 'active'
      },
      {
        id: 2,
        name: 'Q4 2023 Financial Report',
        category: 'Financial',
        date: '2024-02-01',
        type: 'xlsx',
        size: '1.8 MB',
        tags: ['financial', 'quarterly'],
        physicalLocation: 'Finance Department',
        status: 'active'
      },
      {
        id: 3,
        name: 'Employee Handbook 2024',
        category: 'HR',
        date: '2024-01-01',
        type: 'pdf',
        size: '3.2 MB',
        tags: ['hr', 'policies'],
        physicalLocation: 'HR Office',
        status: 'active'
      },
      {
        id: 4,
        name: 'Non-Disclosure Agreement',
        category: 'Legal',
        date: '2024-02-05',
        type: 'docx',
        size: '1.2 MB',
        tags: ['nda', 'confidential'],
        physicalLocation: 'Legal Office',
        status: 'active'
      },
      {
        id: 5,
        name: 'Invoice #12345',
        category: 'Invoices',
        date: '2024-02-10',
        type: 'pdf',
        size: '0.9 MB',
        tags: ['invoice', 'payment'],
        physicalLocation: 'Cabinet B-3',
        status: 'archived'
      },
      {
        id: 6,
        name: 'Annual Budget Proposal',
        category: 'Financial',
        date: '2024-01-20',
        type: 'xlsx',
        size: '2.8 MB',
        tags: ['budget', 'proposal'],
        physicalLocation: 'Finance Department',
        status: 'draft'
      },
      {
        id: 7,
        name: 'Employee Performance Review Template',
        category: 'HR',
        date: '2024-01-25',
        type: 'docx',
        size: '1.5 MB',
        tags: ['hr', 'review'],
        physicalLocation: 'HR Office',
        status: 'active'
      },
      {
        id: 8,
        name: 'Project Alpha Contract',
        category: 'Contracts',
        date: '2024-02-12',
        type: 'pdf',
        size: '3.5 MB',
        tags: ['project', 'contract'],
        physicalLocation: 'Cabinet A-2',
        status: 'active'
      },
      {
        id: 9,
        name: 'Legal Compliance Checklist',
        category: 'Legal',
        date: '2024-01-18',
        type: 'xlsx',
        size: '1.1 MB',
        tags: ['legal', 'compliance'],
        physicalLocation: 'Legal Office',
        status: 'active'
      },
      {
        id: 10,
        name: 'Invoice #12346',
        category: 'Invoices',
        date: '2024-02-15',
        type: 'pdf',
        size: '1.0 MB',
        tags: ['invoice', 'payment'],
        physicalLocation: 'Cabinet B-4',
        status: 'archived'
      },
      {
        id: 11,
        name: 'Marketing Budget Q1',
        category: 'Financial',
        date: '2024-02-20',
        type: 'xlsx',
        size: '2.3 MB',
        tags: ['marketing', 'budget'],
        physicalLocation: 'Finance Department',
        status: 'active'
      },
      {
        id: 12,
        name: 'Training Schedule 2024',
        category: 'HR',
        date: '2024-02-25',
        type: 'docx',
        size: '1.8 MB',
        tags: ['training', 'schedule'],
        physicalLocation: 'HR Office',
        status: 'active'
      },
      {
        id: 13,
        name: 'Service Agreement Renewal',
        category: 'Contracts',
        date: '2024-03-01',
        type: 'pdf',
        size: '3.0 MB',
        tags: ['service', 'agreement'],
        physicalLocation: 'Cabinet A-3',
        status: 'active'
      },
      {
        id: 14,
        name: 'Legal Notice Template',
        category: 'Legal',
        date: '2024-01-30',
        type: 'docx',
        size: '1.4 MB',
        tags: ['legal', 'notice'],
        physicalLocation: 'Legal Office',
        status: 'active'
      },
      {
        id: 15,
        name: 'Invoice #12347',
        category: 'Invoices',
        date: '2024-03-05',
        type: 'pdf',
        size: '0.8 MB',
        tags: ['invoice', 'payment'],
        physicalLocation: 'Cabinet B-5',
        status: 'archived'
      },
      {
        id: 16,
        name: 'Q2 Sales Forecast',
        category: 'Financial',
        date: '2024-03-10',
        type: 'xlsx',
        size: '2.1 MB',
        tags: ['sales', 'forecast'],
        physicalLocation: 'Finance Department',
        status: 'draft'
      },
      {
        id: 17,
        name: 'Holiday Policy Update',
        category: 'HR',
        date: '2024-03-15',
        type: 'docx',
        size: '1.6 MB',
        tags: ['holiday', 'policy'],
        physicalLocation: 'HR Office',
        status: 'active'
      },
      {
        id: 18,
        name: 'Partnership Agreement 2024',
        category: 'Contracts',
        date: '2024-03-20',
        type: 'pdf',
        size: '3.8 MB',
        tags: ['partnership', 'agreement'],
        physicalLocation: 'Cabinet A-4',
        status: 'active'
      },
      {
        id: 19,
        name: 'Intellectual Property Policy',
        category: 'Legal',
        date: '2024-03-25',
        type: 'docx',
        size: '1.7 MB',
        tags: ['intellectual', 'property'],
        physicalLocation: 'Legal Office',
        status: 'active'
      },
      {
        id: 20,
        name: 'Invoice #12348',
        category: 'Invoices',
        date: '2024-04-01',
        type: 'pdf',
        size: '1.1 MB',
        tags: ['invoice', 'payment'],
        physicalLocation: 'Cabinet B-6',
        status: 'archived'
      },
      {
        id: 21,
        name: 'Profit & Loss Statement Q1',
        category: 'Financial',
        date: '2024-04-05',
        type: 'xlsx',
        size: '2.9 MB',
        tags: ['profit', 'loss'],
        physicalLocation: 'Finance Department',
        status: 'active'
      },
      {
        id: 22,
        name: 'Employee Benefits Plan',
        category: 'HR',
        date: '2024-04-10',
        type: 'pdf',
        size: '2.2 MB',
        tags: ['benefits', 'plan'],
        physicalLocation: 'HR Office',
        status: 'active'
      },
      {
        id: 23,
        name: 'Supplier Onboarding Checklist',
        category: 'Contracts',
        date: '2024-04-15',
        type: 'xlsx',
        size: '2.0 MB',
        tags: ['supplier', 'onboarding'],
        physicalLocation: 'Cabinet A-5',
        status: 'active'
      },
      {
        id: 24,
        name: 'Privacy Policy 2024',
        category: 'Legal',
        date: '2024-04-20',
        type: 'pdf',
        size: '2.4 MB',
        tags: ['privacy', 'policy'],
        physicalLocation: 'Legal Office',
        status: 'active'
      },
      {
        id: 25,
        name: 'Invoice #12349',
        category: 'Invoices',
        date: '2024-04-25',
        type: 'pdf',
        size: '1.2 MB',
        tags: ['invoice', 'payment'],
        physicalLocation: 'Cabinet B-7',
        status: 'archived'
      },
      {
        id: 26,
        name: 'Marketing Campaign Budget',
        category: 'Financial',
        date: '2024-05-01',
        type: 'xlsx',
        size: '2.7 MB',
        tags: ['marketing', 'campaign'],
        physicalLocation: 'Finance Department',
        status: 'active'
      },
      {
        id: 27,
        name: 'Employee Training Manual',
        category: 'HR',
        date: '2024-05-05',
        type: 'pdf',
        size: '3.4 MB',
        tags: ['training', 'manual'],
        physicalLocation: 'HR Office',
        status: 'active'
      },
      {
        id: 28,
        name: 'Client Contract Template',
        category: 'Contracts',
        date: '2024-05-10',
        type: 'docx',
        size: '2.6 MB',
        tags: ['client', 'contract'],
        physicalLocation: 'Cabinet A-6',
        status: 'active'
      },
      {
        id: 29,
        name: 'Terms and Conditions 2024',
        category: 'Legal',
        date: '2024-05-15',
        type: 'pdf',
        size: '2.1 MB',
        tags: ['terms', 'conditions'],
        physicalLocation: 'Legal Office',
        status: 'active'
      },
      {
        id: 30,
        name: 'Invoice #12350',
        category: 'Invoices',
        date: '2024-05-20',
        type: 'pdf',
        size: '1.0 MB',
        tags: ['invoice', 'payment'],
        physicalLocation: 'Cabinet B-8',
        status: 'archived'
      }
    
      
      // Add more mock documents as needed
    ];

    setDocuments(mockDocuments);
  }, []);

  const categories = [
    { name: 'All', icon: <FolderOpen className="w-5 h-5" /> },
    { name: 'Contracts', icon: <FileText className="w-5 h-5" /> },
    { name: 'Financial', icon: <File className="w-5 h-5" /> },
    { name: 'Legal', icon: <FileText className="w-5 h-5" /> },
    { name: 'HR', icon: <File className="w-5 h-5" /> },
    { name: 'Invoices', icon: <FileText className="w-5 h-5" /> },
  ];

  const filteredDocuments = documents.filter(doc => 
    doc.name.toLowerCase().includes(searchTerm.toLowerCase()) &&
    (categoryFilter === 'All' || doc.category === categoryFilter)
  );

  const statsData = [
    { title: 'Total Documents', value: documents.length, color: 'bg-blue-500' },
    { title: 'Digital Only', value: '45', color: 'bg-green-500' },
    { title: 'Physical Copies', value: '32', color: 'bg-purple-500' },
    { title: 'Recent Uploads', value: '12', color: 'bg-yellow-500' },
  ];

  return (
    <div className="p-6">
      <BackButton />
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold">Document Archive</h1>
        <Link 
          to="/archive/upload" 
          className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg flex items-center"
        >
          <Upload className="w-5 h-5 mr-2" />
          Upload Document
        </Link>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
        {statsData.map((stat, index) => (
          <div 
            key={index}
            className={`${stat.color} text-white rounded-lg p-6 shadow-lg transform transition-transform duration-200 hover:scale-105`}
          >
            <h3 className="text-lg font-semibold mb-2">{stat.title}</h3>
            <p className="text-3xl font-bold">{stat.value}</p>
          </div>
        ))}
      </div>

      <div className="bg-white rounded-lg shadow-md p-6 mb-6">
        <div className="flex flex-wrap gap-4 mb-6">
          <div className="flex-grow">
            <div className="relative">
              <input
                type="text"
                placeholder="Search documents..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-10 pr-4 py-2 border rounded-lg"
              />
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
            </div>
          </div>
          <div className="flex items-center gap-4">
            <Filter size={20} className="text-gray-400" />
            <select
              value={categoryFilter}
              onChange={(e) => setCategoryFilter(e.target.value)}
              className="border rounded-lg px-4 py-2"
            >
              {categories.map(category => (
                <option key={category.name} value={category.name}>{category.name}</option>
              ))}
            </select>
            <select
              value={dateFilter}
              onChange={(e) => setDateFilter(e.target.value)}
              className="border rounded-lg px-4 py-2"
            >
              <option value="all">All Time</option>
              <option value="today">Today</option>
              <option value="week">This Week</option>
              <option value="month">This Month</option>
              <option value="year">This Year</option>
            </select>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {categories.map((category) => (
            <button
              key={category.name}
              onClick={() => setCategoryFilter(category.name)}
              className={`p-4 rounded-lg border flex items-center gap-3 transition-colors ${
                categoryFilter === category.name
                  ? 'bg-blue-50 border-blue-500 text-blue-700'
                  : 'hover:bg-gray-50'
              }`}
            >
              {category.icon}
              <span className="font-medium">{category.name}</span>
            </button>
          ))}
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-md overflow-hidden">
        <table className="min-w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Name</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Category</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Date</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Type</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Size</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {filteredDocuments.map((doc) => (
              <tr key={doc.id} className="hover:bg-gray-50">
                <td className="px-6 py-4">
                  <div className="flex items-center">
                    <FileText className="w-5 h-5 mr-2 text-gray-400" />
                    <span className="font-medium">{doc.name}</span>
                  </div>
                </td>
                <td className="px-6 py-4">{doc.category}</td>
                <td className="px-6 py-4">{doc.date}</td>
                <td className="px-6 py-4 uppercase">{doc.type}</td>
                <td className="px-6 py-4">{doc.size}</td>
                <td className="px-6 py-4">
                  <div className="flex space-x-3">
                    <Link to={`/archive/${doc.id}`} className="text-blue-600 hover:text-blue-900">
                      View
                    </Link>
                    <button className="text-blue-600 hover:text-blue-900">
                      Download
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ArchiveDashboard;